/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Segment, Grid, Divider, Header, List, Popup,
  Button, Icon, Dimmer, Loader, Modal
} from "semantic-ui-react";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ProblemCard from "./ProblemCard";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import TsExpertReport from "./TsExpertReport";
import SuggestedActionsReport from "./SuggestedActionsReport";
import Utils from "../utilities/Utils";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

const UtilsInstance = new Utils();

export class TSExpert extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      lastUpdate: new Date(),
      networkTag: "",
      startTime: "",
      uptime: "",
      problems: [],
      pingLimit: "",
      ntp: false,
      mediaCounters: [],
      interfaceCounters: [],
      groupedProblems: {
        "duplicatedIp": [],
        "avgPingExceededLimit": [],
        "dhcpConfigDetected": [],
        "packetLossLimitExceeded": [],
        "inactivePort": [],
        "portNotInAutonegotiation": [],
        "portNotInFullDuplex": [],
        "interfaceSpeedLessThan100": [],
        "portWithHardwareFault": [],
        "addressConflictDetected": [],
        "mediaCounters": [],
        "interfaceCounters": [],
        "faults": [],
        "lostIp": []
      },
      currentProblemType: "",
      currentProblemList: [],
      displayProblemsList: false,
      // The report
      report: "",
      isGenerateReportDimmerActive: false,
      suggestedActionsReport: "",
      isGenerateSuggestedActionsReportDimmerActive: false,
      checkMediaCounters: false,
      checkInterfaceCounters: false,
      // Check problem modal
      showModal: false,
      // Are internal ports being ignored?
      portStateFilter: false
    };
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + " " + Strings.RELATIVE_YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + " " + Strings.RELATIVE_MONTH);
      }
      else {
        out.push(md + " " + Strings.RELATIVE_MONTHS);
      }
    }
    if (dd > 0) out.push(dd + " " + Strings.RELATIVE_DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + " " + Strings.RELATIVE_HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + " " + Strings.RELATIVE_MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      if (uptimeInSeconds >= 60) {
        const uptimeInMillis = uptimeInSeconds * 1000;
        const timeNow = new Date().getTime();
        const whenWasTurnedOn = timeNow - uptimeInMillis;
        const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
        return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
      }
      else {
        return Strings.LESS_THAN_A_MINUTE;
      }
    }
  }

  fetchData = async (route) => {
    return await fetch(Constants.REQUEST_IP_ADDRESS + route, { mode: "cors" })
      .then(res => res.json())
      .then(data => data);
  }

  retrieveData = async () => {
    let promissesArray = [];

    // Start to fetch all data here, put the promisses returned in an array
    promissesArray.push(this.fetchData("mediaCounters"));                // [0]
    promissesArray.push(this.fetchData("interfaceCounters"));            // [1]
    promissesArray.push(this.fetchData("tsExpert"));                     // [2]
    promissesArray.push(this.fetchData("startTime"));                    // [3]
    promissesArray.push(this.fetchData("tsExpertConfig"));               // [4]
    promissesArray.push(this.fetchData("pingLimitConfig"));              // [5]
    promissesArray.push(this.fetchData("pingLossLimitConfig"));          // [6]
    promissesArray.push(this.fetchData("tag"));                          // [7]
    promissesArray.push(this.fetchData("ntp"));                          // [8]
    promissesArray.push(this.fetchData("filterPortsState"));             // [9]

    // And wait until all of them have finished
    let resolvedPromisses = await Promise.all(promissesArray);

    let mediaCounters = resolvedPromisses[0].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let interfaceCounters = resolvedPromisses[1].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let problems = resolvedPromisses[2];
    let startTime = resolvedPromisses[3].startTime;

    let tsExpertConfig = resolvedPromisses[4];
    let pingLimit = resolvedPromisses[5].pingLimit;
    let packetLossLimit = resolvedPromisses[6].pingLossLimit;

    this.setState({
      mediaCounters: mediaCounters,
      interfaceCounters: interfaceCounters,
      problems: problems,
      startTime: startTime,
      pingLimit: pingLimit,
      packetLossLimit: packetLossLimit,
      checkMediaCounters: tsExpertConfig.isMediaCountersProblemChecked,
      checkInterfaceCounters: tsExpertConfig.isInterfaceCountersProblemChecked,
      networkTag: resolvedPromisses[7].tag,
      ntp: resolvedPromisses[8].ntp,
      portStateFilter: resolvedPromisses[9].filter
    }, () => {
      this.groupProblemsByType();
    });
  }

  retrieveUptimeData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "startTime", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        uptime: this.formatToRelativeTime(data.startTime)
      }));
  }

  checkProblemsListSize = () => {
    if (this.state.displayProblemsList) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";
    }
    else {
      document.getElementById("problems-list").style.display = "none";
      document.getElementById("no-problem-detected-header").style.display = "block";
    }
  }

  groupProblemsByType = () => {
    let newGroupedProblems = {
      "duplicatedIp": [],
      "avgPingExceededLimit": [],
      "dhcpConfigDetected": [],
      "packetLossLimitExceeded": [],
      "inactivePort": [],
      "portNotInAutonegotiation": [],
      "portNotInFullDuplex": [],
      "interfaceSpeedLessThan100": [],
      "portWithHardwareFault": [],
      "addressConflictDetected": [],
      "mediaCounters": [],
      "interfaceCounters": [],
      "faults": [],
      "lostIp": [],
    };

    let displayProblemsList = false;

    for (let i = 0; i < this.state.problems.length; i++) {
      if (this.state.problems[i].type === Constants.DUPLICATE_IP_ERROR_TYPE) {
        newGroupedProblems.duplicatedIp.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.PING_ERROR_TYPE) {
        newGroupedProblems.avgPingExceededLimit.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.DHCP_ERROR_TYPE) {
        newGroupedProblems.dhcpConfigDetected.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.PACKET_LOSS_ERROR_TYPE) {
        newGroupedProblems.packetLossLimitExceeded.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.INACTIVE_PORT_ERROR_TYPE) {
        newGroupedProblems.inactivePort.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
        newGroupedProblems.portNotInAutonegotiation.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
        newGroupedProblems.portNotInFullDuplex.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.INTERFACE_SPEED_ERROR_TYPE) {
        newGroupedProblems.interfaceSpeedLessThan100.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.HARDWARE_FAULT_ERROR_TYPE) {
        newGroupedProblems.portWithHardwareFault.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.ADDR_CONFLICT_ERROR_TYPE) {
        newGroupedProblems.addressConflictDetected.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.FAULT_ERROR_TYPE) {
        newGroupedProblems.faults.push(this.state.problems[i]);
        displayProblemsList = true;
      }
      else if (this.state.problems[i].type === Constants.LOST_IP_ERROR_TYPE) {
        newGroupedProblems.lostIp.push(this.state.problems[i]);
        displayProblemsList = true;
      }
    }

    if (this.state.checkMediaCounters) {
      for (let i = 0; i < this.state.mediaCounters.length; i++) {
        // Só verifique devices que suportam media counters
        if (this.state.mediaCounters[i].media_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
          let problem = {
            "id": this.state.mediaCounters[i].id + " / mediaCounters",
            "ip": this.state.mediaCounters[i].ip,
            "mac": this.state.mediaCounters[i].id,
            "ports": [],
            "type": "mediaCounters",
            "time": this.state.mediaCounters[i].last_media_counters_increment_time,
            "ntp": this.state.ntp
          };

          // Veja quais portas possuem incremento de media counter
          for (let j = 0; j < this.state.mediaCounters[i].instances.length; j++) {
            if (this.state.mediaCounters[i].instances[j].has_media_counters_increment) {
              if ((this.state.portStateFilter === true && !this.isInternalPort(this.state.mediaCounters[i].instances[j]))
                || this.state.portStateFilter === false
              ) {
                problem.ports.push(this.state.mediaCounters[i].instances[j].interface_label);
              }
            }
          }

          // Se alguma porta do device tiver incremento de media counter 
          // salve no array para mostrar o evento no frontend 
          if (problem.ports.length > 0) {
            newGroupedProblems.mediaCounters.push(problem);
            displayProblemsList = true;
          }
        }
      }
    }

    if (this.state.checkInterfaceCounters) {
      for (let i = 0; i < this.state.interfaceCounters.length; i++) {
        // Só verifique devices que suportam interface counters
        if (this.state.interfaceCounters[i].iface_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
          let problem = {
            "id": this.state.interfaceCounters[i].id + " / interfaceCounters",
            "ip": this.state.interfaceCounters[i].ip,
            "mac": this.state.interfaceCounters[i].id,
            "ports": [],
            "type": "interfaceCounters",
            "time": this.state.interfaceCounters[i].last_interface_counters_increment_time,
            "ntp": this.state.ntp
          };

          // Veja quais portas possuem incremento de interface counters
          for (let j = 0; j < this.state.interfaceCounters[i].instances.length; j++) {
            if (this.state.interfaceCounters[i].instances[j].has_interface_counters_increment) {
              if ((this.state.portStateFilter === true && !this.isInternalPort(this.state.interfaceCounters[i].instances[j]))
                || this.state.portStateFilter === false
              ) {
                problem.ports.push(this.state.interfaceCounters[i].instances[j].interface_label);
              }
            }
          }

          // Se alguma porta do device tiver incremento de interface counter 
          // salve no array para mostrar o evento no frontend 
          if (problem.ports.length > 0) {
            newGroupedProblems.interfaceCounters.push(problem);
            displayProblemsList = true;
          }
        }
      }
    }

    this.setState({
      groupedProblems: newGroupedProblems,
      displayProblemsList: displayProblemsList
    }, () => {
      this.checkProblemsListSize();
    });
  }

  isInternalPort = (port) => {
    let interface_label = port.interface_label;
    let interface_type = port.interface_type;

    if (interface_type == "Internal (1)"
      || interface_label.toUpperCase().includes("internal".toUpperCase())
      || interface_label.toUpperCase().includes("wlan".toUpperCase())
      || interface_label.toUpperCase().includes("wsd".toUpperCase())
      || interface_label.toUpperCase().includes("internal".toUpperCase())
      || interface_label.toUpperCase().includes("loopback".toUpperCase())
      || interface_label.toUpperCase().includes("vlan".toUpperCase())
      || interface_label.toUpperCase().includes("pseudo".toUpperCase())
      || interface_label.toUpperCase().includes("vap".toUpperCase())
      || interface_label.toUpperCase().includes("virtual".toUpperCase())
      || interface_label.toUpperCase().includes("wan".toUpperCase())) {
      return true;
    }
    else {
      return false;
    }
  }

  // ------ Events List ------
  getListItem = (problemType, groupedProblemList) => {
    if (groupedProblemList.length > 0) {
      return (
        <List.Item>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron right"
              onClick={this.handleDetailsButtonClick(problemType, groupedProblemList)} />
          </List.Content>
          {this.getListContent(problemType)}
        </List.Item>
      );
    }
    else {
      return "";
    }
  }

  handleDetailsButtonClick = (problemType, groupedProblemList) => () => {
    this.setState({
      currentProblemType: problemType,
      currentProblemList: groupedProblemList
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "none";
      document.getElementById("task-details").style.display = "block";
    });
  }

  getListContent = (problemType) => {
    if (problemType === Constants.PING_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.GROUP_PING_LIMIT_HEADER}</List.Header>
          <List.Description>
            {Strings.THE_LIMIT_VALUE_IS} <strong>{this.state.pingLimit}{Strings.MILLISECONDS_SUFFIX}</strong>.
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.GROUP_DUPLICATE_IP_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.GROUP_DUPLICATE_IP_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.DHCP_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.DHCP_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.DHCP_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PACKET_LOSS_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.GROUP_PACKET_LOSS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.THE_LIMIT_VALUE_IS} <strong>{this.state.packetLossLimit}%</strong>.
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.INACTIVE_PORT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.INACTIVE_PORT_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.NOT_IN_AUTONEGOTIATION_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.NOT_IN_AUTONEGOTIATION_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.NOT_IN_FULL_DUPLEX_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.NOT_IN_FULL_DUPLEX_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.INTERFACE_SPEED_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.INTERFACE_SPEED_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.HARDWARE_FAULT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.HARDWARE_FAULT_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.ADDR_CONFLICT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.ADDR_CONFLICT_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.MEDIA_COUNTERS_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.MEDIA_COUNTERS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.ADDR_CONFLICT_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.INTERFACE_COUNTERS_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.INTERFACE_COUNTERS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.ADDR_CONFLICT_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.FAULTS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.FAULTS_LIST_DESCR}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.LOST_IP_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.LOST_IP_DESCR}
          </List.Description>
        </List.Content>
      );
    }
  }

  // ------ Actions ------
  getActions = () => {
    if (this.state.currentProblemType === Constants.PING_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PING_LIMIT_SUGGESTION_1}</Header>
          <Header as="h3">{Strings.PING_LIMIT_SUGGESTION_2}</Header>

          <ul>
            <li>{Strings.PING_LIMIT_SUGGESTION_4}</li>
          </ul>

          <Header as="h3">{Strings.PING_LIMIT_SUGGESTION_5}</Header>
          <ul>
            <li>{Strings.PING_LIMIT_SUGGESTION_6}</li>
            <li>{Strings.PING_LIMIT_SUGGESTION_7}</li>
          </ul>

          <Header as="h3">{Strings.PING_LIMIT_SUGGESTION_8}</Header>
          <ul>
            <li>{Strings.PING_LIMIT_SUGGESTION_9}</li>
          </ul>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DUPLICATE_IP_SUGGESTION_1}</Header>
          <p>{Strings.DUPLICATE_IP_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.DHCP_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DHCP_SUGGESTION_1}</Header>
          <p>{Strings.DHCP_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PACKET_LOSS_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PACKET_LOSS_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.PACKET_LOSS_SUGGESTION_2}</li>
            <li>{Strings.PACKET_LOSS_SUGGESTION_3}</li>
            <li>{Strings.PACKET_LOSS_SUGGESTION_4}</li>
            <li>{Strings.PACKET_LOSS_SUGGESTION_5}</li>
            <li>{Strings.PACKET_LOSS_SUGGESTION_6}</li>
            <li>{Strings.PACKET_LOSS_SUGGESTION_7}</li>
          </ul>
          <p><strong>{Strings.OBS}</strong>{Strings.PACKET_LOSS_SUGGESTION_8}</p>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.INACTIVE_PORT_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.INACTIVE_PORT_SUGGESTION_2}</li>
            <li>{Strings.INACTIVE_PORT_SUGGESTION_3}</li>
            <li>{Strings.INACTIVE_PORT_SUGGESTION_4}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_2}</li>
            <li>{Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_3}</li>
            <li>{Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_4}</li>
            <li>{Strings.NOT_IN_AUTONEGOTIATION_SUGGESTION_5}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_2}</li>
            <li>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_3}</li>
          </ul>
          <p><strong>{Strings.OBS}</strong>{Strings.NOT_IN_FULL_DUPLEX_SUGGESTION_4}</p>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.INTERFACE_SPEED_SUGGESTION_1}</Header>
          <p>{Strings.INTERFACE_SPEED_SUGGESTION_2}</p>
          <p>{Strings.INTERFACE_SPEED_SUGGESTION_3}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.HARDWARE_FAULT_SUGGESTION_1}</Header>
          <p>{Strings.HARDWARE_FAULT_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.ADDR_CONFLICT_DETECTED_SUGGESTION_1}</Header>
          <p>{Strings.ADDR_CONFLICT_DETECTED_SUGGESTION_2}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.MEDIA_COUNTERS_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.MEDIA_COUNTERS_SUGGESTION_1}</Header>
          <p>{Strings.MEDIA_COUNTERS_SUGGESTION_4}</p>
          <Button
            fluid
            content={Strings.SUGGESTED_ACTIONS_BUTTON}
            color="teal"
            onClick={this.generateSuggestedActionsReport} />

          <div style={mediaInterfaceCountersPdfLinkStyle}>
            <PDFDownloadLink
              document={this.state.suggestedActionsReport}
              fileName={Strings.SUGGESTED_ACTIONS_FILENAME}>
              {({ loading }) => {
                if (loading) {
                  return Strings.FINISHING;
                }
                else {
                  if (this.state.isGenerateSuggestedActionsReportDimmerActive) {
                    this.setGeneratingSuggestedActionsDimmerState(false);
                  }
                  return Strings.SAVE_SUGGESTED_ACTIONS;
                }
              }}
            </PDFDownloadLink>
          </div>

          <Dimmer page active={this.state.isGenerateSuggestedActionsReportDimmerActive} >
            <Loader size="big">{Strings.GENERATING_ACTIONS_SUGESTIONS_WAITING}</Loader>
          </Dimmer>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.INTERFACE_COUNTERS_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.INTERFACE_COUNTERS_SUGGESTION_1}</Header>
          <p>{Strings.INTERFACE_COUNTERS_SUGGESTION_4}</p>
          <Button
            fluid
            content={Strings.SUGGESTED_ACTIONS_BUTTON}
            color="teal"
            onClick={this.generateSuggestedActionsReport} />

          <div style={mediaInterfaceCountersPdfLinkStyle}>
            <PDFDownloadLink
              document={this.state.suggestedActionsReport}
              fileName={Strings.SUGGESTED_ACTIONS_FILENAME}>
              {({ loading }) => {
                if (loading) {
                  return Strings.FINISHING;
                }
                else {
                  if (this.state.isGenerateSuggestedActionsReportDimmerActive) {
                    this.setGeneratingSuggestedActionsDimmerState(false);
                  }
                  return Strings.SAVE_SUGGESTED_ACTIONS;
                }
              }}
            </PDFDownloadLink>
          </div>

          <Dimmer page active={this.state.isGenerateSuggestedActionsReportDimmerActive} >
            <Loader size="big">{Strings.GENERATING_ACTIONS_SUGESTIONS_WAITING}</Loader>
          </Dimmer>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.FAULT_SUGGESTION_1}</Header>
          <ul>
            <li>{Strings.FAULT_SUGGESTION_2}</li>
            <li>{Strings.FAULT_SUGGESTION_3}</li>
            <li>{Strings.FAULT_SUGGESTION_4}</li>
            <li>{Strings.FAULT_SUGGESTION_5}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.LOST_IP_SUGGESTION_1}</Header>
          <p>{Strings.LOST_IP_SUGGESTION_2}</p>

        </Segment>
      );
    }
  }

  getProblemCards = () => {
    if (this.state.currentProblemList.length > 1) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem.id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem} />
            ))
          }
          <Button
            fluid
            color='green'
            onClick={this.handleBatchCheckButtonClick}>
            {Strings.BATCH_CHECK}
          </Button>
        </Segment>
      );
    }
    else {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem.id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem} />
            ))
          }
        </Segment>
      );
    }
  }

  handleCloseButtonClick = () => {
    this.setState({
      currentProblemType: "",
      currentProblemList: []
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "block";
      document.getElementById("task-details").style.display = "none";
    });
  }

  handleBatchCheckButtonClick = () => {
    let data = JSON.stringify({
      type: this.state.currentProblemType,
      problems: this.state.currentProblemList
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "solveAllProblems_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.BATCH_CHECK_SUCCESS);

        // Mostre que não existem eventos
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      })
      .catch((error) => {
        let result = JSON.parse(error.message);

        let message = "";

        if (result.notSolved.length > 0) {

          message += this.getInitialErrorMessage(result.type) + "\n";

          for (let i = 0; i < result.notSolved.length; i++) {
            message += this.getErrorMessage(result.notSolved[i]);
          }
        }

        alert(message);

        // Feche a seção de solução
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      });
  }

  getInitialErrorMessage = (problemType) => {
    if (problemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_DUPLICATE_IP;
    }
    else if (problemType === Constants.PING_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_PING;
    }
    else if (problemType === Constants.DHCP_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_DHCP;
    }
    else if (problemType === Constants.PACKET_LOSS_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_PACKET_LOSS;
    }
    else if (problemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_INACTIVE_PORT;
    }
    else if (problemType === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_AUTONEGOTIATION;
    }
    else if (problemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_DUPLEX;
    }
    else if (problemType === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_INTERFACE_SPEED;
    }
    else if (problemType === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_HARDWARE_FAULT;
    }
    else if (problemType === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_ADDRESS_CONFLICT;
    }
    else if (problemType === Constants.MEDIA_COUNTERS_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_RETRY;
    }
    else if (problemType === Constants.INTERFACE_COUNTERS_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_RETRY;
    }
    else if (problemType === Constants.FAULT_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_FAULT;
    }
    else if (problemType === Constants.LOST_IP_ERROR_TYPE) {
      return Strings.UNRESOLVED_PROBLEM_LOST_IP;
    }
    else {
      return Strings.UNRESOLVED_PROBLEM_GENERIC;
    }
  }

  getErrorMessage = (problem) => {
    if (problem.type === Constants.DUPLICATE_IP_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_DUPLICATE_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac1 + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac2 + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.PING_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_AVERAGE_PING + problem.ping.toFixed(2) + Strings.MILLISECONDS_SUFFIX + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.DHCP_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_CONFIGURATION_METHOD + problem.config_method + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.PACKET_LOSS_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_LOST_PINGS + problem.lostPacketsPercentage + "%\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_PORT + problem.interface_label + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_PORT + problem.interface_label + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_NEGOTIATION_STATUS + problem.negotiation_status + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_PORT + problem.interface_label + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_DUPLEX_MODE + problem.duplex + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_PORT + problem.interface_label + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_INTERFACE_SPEED + problem.interface_speed + Strings.MEGABITS_PER_SECOND_SUFFIX + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_PORT + problem.interface_label + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_LOCAL_HARDWARE_FAULT + problem.local_hardware_fault + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_ACD_STATUS + problem.acd_status + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.MEDIA_COUNTERS_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.INTERFACE_COUNTERS_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.FAULT_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n\n";
      return errorMsg;
    }
    else if (problem.type === Constants.LOST_IP_ERROR_TYPE) {
      let errorMsg = Strings.TS_EXPERT_ERROR_DEVICE;
      errorMsg += Strings.TS_EXPERT_ERROR_IP + problem.ip + "\n";
      errorMsg += Strings.TS_EXPERT_ERROR_MAC + problem.mac + "\n\n";
      return errorMsg;
    }
    else {
      return "";
    }
  }

  // ------ TS Expert Report ------
  generateTsExpertReport = async () => {
    let promissesArray = [];

    promissesArray.push(this.fetchData("mediaCounters"));                // [0]
    promissesArray.push(this.fetchData("interfaceCounters"));            // [1]
    promissesArray.push(this.fetchData("tsExpert"));                     // [2]
    promissesArray.push(this.fetchData("startTime"));                    // [3]
    promissesArray.push(this.fetchData("tsExpertConfig"));               // [4]
    promissesArray.push(this.fetchData("filterPortsState"));             // [5]

    let resolvedPromisses = await Promise.all(promissesArray);

    let mediaCounters = resolvedPromisses[0].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let interfaceCounters = resolvedPromisses[1].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let problems = resolvedPromisses[2];
    let startTime = resolvedPromisses[3].startTime;
    let checkMediaCounters = resolvedPromisses[4].isMediaCountersProblemChecked;
    let checkInterfaceCounters = resolvedPromisses[4].isInterfaceCountersProblemChecked;
    let portStateFilter = resolvedPromisses[5].filter;

    let filteredMediaCounters = [];
    let filteredInterfaceCounters = [];

    if (checkMediaCounters) {
      for (let i = 0; i < mediaCounters.length; i++) {

        if (mediaCounters[i].media_counters_attr_supported === Constants.ATTR_SUP_TRUE) {

          let hasMediaCounterIncrements = false;

          for (let j = 0; j < mediaCounters[i].instances.length; j++) {
            if (mediaCounters[i].instances[j].has_media_counters_increment) {
              if ((portStateFilter == true && !this.isInternalPort(mediaCounters[i].instances[j]))
                || portStateFilter == false) {
                hasMediaCounterIncrements = true;
                break;
              }
            }
          }

          if (hasMediaCounterIncrements) {
            filteredMediaCounters.push(mediaCounters[i]);
          }

        }

      }
    }

    if (checkInterfaceCounters) {
      for (let i = 0; i < interfaceCounters.length; i++) {

        if (interfaceCounters[i].iface_counters_attr_supported === Constants.ATTR_SUP_TRUE) {

          let hasInterfaceCountersIncrements = false;

          for (let j = 0; j < interfaceCounters[i].instances.length; j++) {
            if (interfaceCounters[i].instances[j].has_interface_counters_increment) {
              if ((portStateFilter == true && !this.isInternalPort(interfaceCounters[i].instances[j]))
                || portStateFilter == false) {
                hasInterfaceCountersIncrements = true;
                break;
              }
            }
          }

          if (hasInterfaceCountersIncrements) {
            filteredInterfaceCounters.push(interfaceCounters[i]);
          }

        }

      }
    }

    let reportGroupedProblems = {
      "duplicatedIp": [],
      "avgPingExceededLimit": [],
      "dhcpConfigDetected": [],
      "packetLossLimitExceeded": [],
      "inactivePort": [],
      "portNotInAutonegotiation": [],
      "portNotInFullDuplex": [],
      "interfaceSpeedLessThan100": [],
      "portWithHardwareFault": [],
      "addressConflictDetected": [],
      "mediaCounters": [],
      "interfaceCounters": [],
      "faults": [],
      "lostIp": [],
    };

    for (let i = 0; i < problems.length; i++) {
      if (problems[i].type === Constants.DUPLICATE_IP_ERROR_TYPE) {
        reportGroupedProblems.duplicatedIp.push(problems[i]);
      }
      else if (problems[i].type === Constants.PING_ERROR_TYPE) {
        reportGroupedProblems.avgPingExceededLimit.push(problems[i]);
      }
      else if (problems[i].type === Constants.DHCP_ERROR_TYPE) {
        reportGroupedProblems.dhcpConfigDetected.push(problems[i]);
      }
      else if (problems[i].type === Constants.PACKET_LOSS_ERROR_TYPE) {
        reportGroupedProblems.packetLossLimitExceeded.push(problems[i]);
      }
      else if (problems[i].type === Constants.INACTIVE_PORT_ERROR_TYPE) {
        reportGroupedProblems.inactivePort.push(problems[i]);
      }
      else if (problems[i].type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
        reportGroupedProblems.portNotInAutonegotiation.push(problems[i]);
      }
      else if (problems[i].type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
        reportGroupedProblems.portNotInFullDuplex.push(problems[i]);
      }
      else if (problems[i].type === Constants.INTERFACE_SPEED_ERROR_TYPE) {
        reportGroupedProblems.interfaceSpeedLessThan100.push(problems[i]);
      }
      else if (problems[i].type === Constants.HARDWARE_FAULT_ERROR_TYPE) {
        reportGroupedProblems.portWithHardwareFault.push(problems[i]);
      }
      else if (problems[i].type === Constants.ADDR_CONFLICT_ERROR_TYPE) {
        reportGroupedProblems.addressConflictDetected.push(problems[i]);
      }
      else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
        reportGroupedProblems.faults.push(problems[i]);
      }
      else if (problems[i].type === Constants.LOST_IP_ERROR_TYPE) {
        reportGroupedProblems.lostIp.push(problems[i]);
      }
    }

    this.setState({ report: "" }, () => {
      this.setGeneratingDimmerState(true);
      this.setState({
        report:
          <TsExpertReport
            nowMillis={Date.now()}
            startTime={startTime}
            duplicatedIp={reportGroupedProblems.duplicatedIp}
            avgPingExceededLimit={reportGroupedProblems.avgPingExceededLimit}
            dhcpConfigDetected={reportGroupedProblems.dhcpConfigDetected}
            packetLossLimitExceeded={reportGroupedProblems.packetLossLimitExceeded}
            inactivePort={reportGroupedProblems.inactivePort}
            portNotInAutonegotiation={reportGroupedProblems.portNotInAutonegotiation}
            portNotInFullDuplex={reportGroupedProblems.portNotInFullDuplex}
            interfaceSpeedLessThan100={reportGroupedProblems.interfaceSpeedLessThan100}
            portWithHardwareFault={reportGroupedProblems.portWithHardwareFault}
            addressConflictDetected={reportGroupedProblems.addressConflictDetected}
            mediaCounters={filteredMediaCounters}
            interfaceCounters={filteredInterfaceCounters}
            faults={reportGroupedProblems.faults}
            lostIp={reportGroupedProblems.lostIp}
          />
      });
    });
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_LIST_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  // ------ TS Expert Modal ------
  closeModal = () => {
    this.props.onProblemSolve(false, {});
    this.setState({ showModal: false });
  }

  handleCheckProblemClick = () => {
    // Se o usuário escolheu realmente conferir o evento, passamos ele para
    // a função de solucionar evento e passamos true para forçar a remoção
    this.solveProblem(this.props.solveProblem.problem, true);
  }

  solveProblem = (problem, forceSolve) => {
    fetch(Constants.REQUEST_IP_ADDRESS + "solveProblem_POST", {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({
        problem: problem,
        forceSolve: forceSolve
      })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        this.setState({ showModal: false }, () => {
          alert(Strings.PROBLEM_CHECKED);
          this.props.onProblemSolve(false, {});
          document.getElementById(problem.id).style.display = "none";
          this.retrieveData2();
        });
      })
      .catch((error) => {
        this.setState({ showModal: false }, () => {
          alert(Strings.PROBLEM_CHECK_ERROR + "\n" + Strings.REASON_DP + error.message);
          this.props.onProblemSolve(false, {});
        });
      });
  }

  checkProblem = async (problem) => {
    // Se o tipo de problema for a porta estar inativa,
    if (problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      let data = JSON.stringify({
        mac: problem.mac,
        interface_label: problem.interface_label
      });

      let port = await fetch(Constants.REQUEST_IP_ADDRESS + "devicePort", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(res => res.json())
        .then(data => data);

      console.log(port);

      // Primeiro verificamos se a porta ainda está inativa, se ela estiver, 
      // perguntamos para o usuário se ele tem certeza que deseja marcar o problema como conferido
      if (port.link_status === "Inactive") {
        this.setState({ showModal: true });
      }
      else {
        this.solveProblem(problem, false);
      }
    }
    else {
      this.solveProblem(problem, false);
    }
  }

  retrieveData2 = async () => {
    let promissesArray = [];

    // Start to fetch all data here, put the promisses returned in an array
    promissesArray.push(this.fetchData("mediaCounters"));                // [0]
    promissesArray.push(this.fetchData("interfaceCounters"));            // [1]
    promissesArray.push(this.fetchData("tsExpert"));                     // [2]
    promissesArray.push(this.fetchData("startTime"));                    // [3]
    promissesArray.push(this.fetchData("tsExpertConfig"));               // [4]
    promissesArray.push(this.fetchData("pingLimitConfig"));              // [5]
    promissesArray.push(this.fetchData("pingLossLimitConfig"));          // [6]
    promissesArray.push(this.fetchData("tag"));                          // [7]
    promissesArray.push(this.fetchData("ntp"));                          // [8]
    promissesArray.push(this.fetchData("filterPortsState"));             // [9]

    // And wait until all of them have finished
    let resolvedPromisses = await Promise.all(promissesArray);

    let mediaCounters = resolvedPromisses[0].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let interfaceCounters = resolvedPromisses[1].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let problems = resolvedPromisses[2];
    let startTime = resolvedPromisses[3].startTime;
    let tsExpertConfig = resolvedPromisses[4];
    let pingLimit = resolvedPromisses[5].pingLimit;
    let packetLossLimit = resolvedPromisses[6].pingLossLimit;
    let hasMediaCountersIncrement = UtilsInstance.hasMediaCountersIncrement(mediaCounters);
    let hasInterfaceCountersIncrement = UtilsInstance.hasInterfaceCountersIncrement(interfaceCounters);
    let portStateFilter = resolvedPromisses[9].filter;

    // Se ao conferir o evento existir pelo menos um outro event no TS Expert
    if (problems.length > 0 || hasMediaCountersIncrement || hasInterfaceCountersIncrement) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";

      let newGroupedProblems = this.groupProblemsByType2(
        problems,
        tsExpertConfig.isMediaCountersProblemChecked,
        tsExpertConfig.isInterfaceCountersProblemChecked,
        mediaCounters, interfaceCounters, portStateFilter
      );

      let currentProblemsList = this.getCurrentProblemsList(newGroupedProblems);

      if (currentProblemsList.length > 0) {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: this.state.currentProblemType,
          currentProblemList: currentProblemsList,
          startTime: startTime,
          pingLimit: pingLimit,
          packetLossLimit: packetLossLimit,
          mediaCounters: mediaCounters,
          interfaceCounters: interfaceCounters,
          checkMediaCounters: tsExpertConfig.isMediaCountersProblemChecked,
          checkInterfaceCounters: tsExpertConfig.isInterfaceCountersProblemChecked,
          networkTag: resolvedPromisses[7].tag,
          ntp: resolvedPromisses[8].ntp,
          portStateFilter: portStateFilter
        });
      }
      else {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: "",
          currentProblemList: [],
          startTime: startTime,
          pingLimit: pingLimit,
          packetLossLimit: packetLossLimit,
          mediaCounters: mediaCounters,
          interfaceCounters: interfaceCounters,
          checkMediaCounters: tsExpertConfig.isMediaCountersProblemChecked,
          checkInterfaceCounters: tsExpertConfig.isInterfaceCountersProblemChecked,
          networkTag: resolvedPromisses[7].tag,
          ntp: resolvedPromisses[8].ntp,
          portStateFilter: portStateFilter
        }, () => {
          document.getElementById("no-task-selected-header").style.display = "block";
          document.getElementById("task-details").style.display = "none";
        });
      }
    }
    else {
      this.setState({
        nowMillis: Date.now(),
        lastUpdate: new Date(),
        problems: [],
        groupedProblems: {
          "duplicatedIp": [],
          "avgPingExceededLimit": [],
          "dhcpConfigDetected": [],
          "packetLossLimitExceeded": [],
          "inactivePort": [],
          "portNotInAutonegotiation": [],
          "portNotInFullDuplex": [],
          "interfaceSpeedLessThan100": [],
          "portWithHardwareFault": [],
          "addressConflictDetected": [],
          "mediaCounters": [],
          "interfaceCounters": [],
          "faults": [],
          "lostIp": [],
        },
        currentProblemType: "",
        currentProblemList: [],
        startTime: startTime,
        pingLimit: pingLimit,
        packetLossLimit: packetLossLimit,
        mediaCounters: mediaCounters,
        interfaceCounters: interfaceCounters,
        checkMediaCounters: tsExpertConfig.isMediaCountersProblemChecked,
        checkInterfaceCounters: tsExpertConfig.isInterfaceCountersProblemChecked,
        networkTag: resolvedPromisses[7].tag,
        ntp: resolvedPromisses[8].ntp,
        portStateFilter: portStateFilter
      }, () => {
        document.getElementById("problems-list").style.display = "none";
        document.getElementById("no-problem-detected-header").style.display = "block";
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";
      });
    }
  }

  groupProblemsByType2 = (problems, checkMediaCounters, checkInterfaceCounters, mediaCounters, interfaceCounters, portStateFilter) => {
    let newGroupedProblems = {
      "duplicatedIp": [],
      "avgPingExceededLimit": [],
      "dhcpConfigDetected": [],
      "packetLossLimitExceeded": [],
      "inactivePort": [],
      "portNotInAutonegotiation": [],
      "portNotInFullDuplex": [],
      "interfaceSpeedLessThan100": [],
      "portWithHardwareFault": [],
      "addressConflictDetected": [],
      "mediaCounters": [],
      "interfaceCounters": [],
      "faults": [],
      "lostIp": [],
    };

    for (let i = 0; i < problems.length; i++) {
      if (problems[i].type === Constants.DUPLICATE_IP_ERROR_TYPE) {
        newGroupedProblems.duplicatedIp.push(problems[i]);
      }
      else if (problems[i].type === Constants.PING_ERROR_TYPE) {
        newGroupedProblems.avgPingExceededLimit.push(problems[i]);
      }
      else if (problems[i].type === Constants.DHCP_ERROR_TYPE) {
        newGroupedProblems.dhcpConfigDetected.push(problems[i]);
      }
      else if (problems[i].type === Constants.PACKET_LOSS_ERROR_TYPE) {
        newGroupedProblems.packetLossLimitExceeded.push(problems[i]);
      }
      else if (problems[i].type === Constants.INACTIVE_PORT_ERROR_TYPE) {
        newGroupedProblems.inactivePort.push(problems[i]);
      }
      else if (problems[i].type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
        newGroupedProblems.portNotInAutonegotiation.push(problems[i]);
      }
      else if (problems[i].type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
        newGroupedProblems.portNotInFullDuplex.push(problems[i]);
      }
      else if (problems[i].type === Constants.INTERFACE_SPEED_ERROR_TYPE) {
        newGroupedProblems.interfaceSpeedLessThan100.push(problems[i]);
      }
      else if (problems[i].type === Constants.HARDWARE_FAULT_ERROR_TYPE) {
        newGroupedProblems.portWithHardwareFault.push(problems[i]);
      }
      else if (problems[i].type === Constants.ADDR_CONFLICT_ERROR_TYPE) {
        newGroupedProblems.addressConflictDetected.push(problems[i]);
      }
      else if (problems[i].type === Constants.FAULT_ERROR_TYPE) {
        newGroupedProblems.faults.push(problems[i]);
      }
      else if (problems[i].type === Constants.LOST_IP_ERROR_TYPE) {
        newGroupedProblems.lostIp.push(problems[i]);
      }
    }

    if (checkMediaCounters) {
      for (let i = 0; i < mediaCounters.length; i++) {
        // Só verifique devices que suportam media counters
        if (mediaCounters[i].media_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
          let problem = {
            "id": mediaCounters[i].id + " / mediaCounters",
            "ip": mediaCounters[i].ip,
            "mac": mediaCounters[i].id,
            "ports": [],
            "type": "mediaCounters",
            "time": mediaCounters[i].last_media_counters_increment_time,
            "ntp": this.state.ntp
          };

          // Veja quais portas possuem incremento de media counter
          for (let j = 0; j < mediaCounters[i].instances.length; j++) {
            if (mediaCounters[i].instances[j].has_media_counters_increment) {
              if ((portStateFilter === true && !this.isInternalPort(mediaCounters[i].instances[j]))
                || portStateFilter === false
              ) {
                problem.ports.push(mediaCounters[i].instances[j].interface_label);
              }
            }
          }

          // Se alguma porta do device tiver incremento de media counter 
          // salve no array para mostrar o evento no frontend 
          if (problem.ports.length > 0) {
            newGroupedProblems.mediaCounters.push(problem);
          }
        }
      }
    }

    if (checkInterfaceCounters) {
      for (let i = 0; i < interfaceCounters.length; i++) {
        // Só verifique devices que suportam interface counters
        if (interfaceCounters[i].iface_counters_attr_supported === Constants.ATTR_SUP_TRUE) {
          let problem = {
            "id": interfaceCounters[i].id + " / interfaceCounters",
            "ip": interfaceCounters[i].ip,
            "mac": interfaceCounters[i].id,
            "ports": [],
            "type": "interfaceCounters",
            "time": interfaceCounters[i].last_interface_counters_increment_time,
            "ntp": this.state.ntp
          };

          // Veja quais portas possuem incremento de interface counters
          for (let j = 0; j < interfaceCounters[i].instances.length; j++) {
            if (interfaceCounters[i].instances[j].has_interface_counters_increment) {
              if ((portStateFilter === true && !this.isInternalPort(interfaceCounters[i].instances[j]))
                || portStateFilter === false
              ) {
                problem.ports.push(interfaceCounters[i].instances[j].interface_label);
              }
            }
          }

          // Se alguma porta do device tiver incremento de interface counter 
          // salve no array para mostrar o evento no frontend 
          if (problem.ports.length > 0) {
            newGroupedProblems.interfaceCounters.push(problem);
          }
        }
      }
    }

    return newGroupedProblems;
  }

  getCurrentProblemsList = (groupedProblems) => {
    if (this.state.currentProblemType === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return groupedProblems.duplicatedIp;
    }
    else if (this.state.currentProblemType === Constants.PING_ERROR_TYPE) {
      return groupedProblems.avgPingExceededLimit;
    }
    else if (this.state.currentProblemType === Constants.DHCP_ERROR_TYPE) {
      return groupedProblems.dhcpConfigDetected;
    }
    else if (this.state.currentProblemType === Constants.PACKET_LOSS_ERROR_TYPE) {
      return groupedProblems.packetLossLimitExceeded;
    }
    else if (this.state.currentProblemType === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return groupedProblems.inactivePort;
    }
    else if (this.state.currentProblemType === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      return groupedProblems.portNotInAutonegotiation;
    }
    else if (this.state.currentProblemType === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return groupedProblems.portNotInFullDuplex;
    }
    else if (this.state.currentProblemType === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      return groupedProblems.interfaceSpeedLessThan100;
    }
    else if (this.state.currentProblemType === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      return groupedProblems.portWithHardwareFault;
    }
    else if (this.state.currentProblemType === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      return groupedProblems.addressConflictDetected;
    }
    else if (this.state.currentProblemType === Constants.MEDIA_COUNTERS_TYPE) {
      return groupedProblems.mediaCounters;
    }
    else if (this.state.currentProblemType === Constants.INTERFACE_COUNTERS_TYPE) {
      return groupedProblems.interfaceCounters;
    }
    else if (this.state.currentProblemType === Constants.FAULT_ERROR_TYPE) {
      return groupedProblems.faults;
    }
    else if (this.state.currentProblemType === Constants.LOST_IP_ERROR_TYPE) {
      return groupedProblems.lostIp;
    }
    else {
      return [];
    }
  }

  // ------ Suggested Actions Report ------
  generateSuggestedActionsReport = async () => {
    this.setState({ suggestedActionsReport: "" }, () => {
      this.setGeneratingSuggestedActionsDimmerState(true);
      this.setState({ suggestedActionsReport: <SuggestedActionsReport /> });
    });
  }

  setGeneratingSuggestedActionsDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateSuggestedActionsReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_SUGGESTIONS_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateSuggestedActionsReportDimmerActive: isActive });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveUptimeData();
    this.setState({ intervalID: setInterval(this.retrieveUptimeData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    // Só tente resolver o problema quando o solve era falso e agora for true
    if (prevProps.solveProblem.solve !== this.props.solveProblem.solve
      && this.props.solveProblem.solve === true) {
      this.checkProblem(this.props.solveProblem.problem);
    }
  }

  render() {
    return (
      <div>

        <Grid style={gridStyle} columns={3} doubling>

          <Grid.Column verticalAlign="middle" style={{ paddingBottom: "0" }}>

            <Header as='h2' style={networkTagStyle}>
              <Popup position='bottom left' hoverable pinned wide="very"
                trigger={
                  <Icon name="question circle" size="small" color="teal" />
                }>
                <Popup.Content>
                  <p>{Strings.TS_EXPERT_POPUP_1}</p>
                  <p>{Strings.TS_EXPERT_POPUP_2}</p>
                  <p>{Strings.TS_EXPERT_POPUP_3}</p>
                  <p><b>{Strings.OBS}</b>{Strings.TS_EXPERT_POPUP_4}</p>
                </Popup.Content>
              </Popup >
              {this.state.networkTag}
            </Header>

          </Grid.Column>

          <Grid.Column verticalAlign="middle" textAlign="center" style={{ paddingBottom: "0" }}>
            <Button
              content={Strings.EXPORT_ACTIONS_LIST}
              color="teal"
              onClick={this.generateTsExpertReport} />

            <Dimmer page active={this.state.isGenerateReportDimmerActive} >
              <Loader size="big">{Strings.GENERATING_ACTIONS_LIST_WAITING}</Loader>
            </Dimmer>

            <PDFDownloadLink
              className="download-link"
              style={pdfLinkStyle}
              document={this.state.report}
              fileName={Strings.TS_EXPERT_REPORT_FILENAME}>
              {({ loading }) => {
                if (loading) {
                  return Strings.FINISHING;
                }
                else {
                  if (this.state.isGenerateReportDimmerActive) {
                    let downloadLink = document.getElementsByClassName("download-link")[0];
                    downloadLink.onclick = () => {
                      setTimeout(() => {
                        if (downloadLink !== null && downloadLink !== undefined) {
                          downloadLink.innerHTML = "";
                        }
                      }, 1500);
                    };
                    this.setGeneratingDimmerState(false);
                  }
                  return Strings.SAVE_ACTIONS_LIST;
                }
              }}
            </PDFDownloadLink>
          </Grid.Column>

          <Grid.Column style={{ paddingBottom: "0" }}>
            <Segment style={floatStyle} size="large" compact textAlign="center">
              <Icon color="green" name="arrow alternate circle up" />
              {Strings.UP_TIME} {this.state.uptime}
            </Segment>
          </Grid.Column>

        </Grid>

        <Grid style={gridStyle} columns={2} doubling>

          <Grid.Column>
            <Segment style={leftSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.EVENTS_LIST}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>
                <List size="medium" animated divided style={listStyle}>
                  {this.getListItem(Constants.DUPLICATE_IP_ERROR_TYPE, this.state.groupedProblems.duplicatedIp)}
                  {this.getListItem(Constants.PING_ERROR_TYPE, this.state.groupedProblems.avgPingExceededLimit)}
                  {this.getListItem(Constants.DHCP_ERROR_TYPE, this.state.groupedProblems.dhcpConfigDetected)}
                  {this.getListItem(Constants.PACKET_LOSS_ERROR_TYPE, this.state.groupedProblems.packetLossLimitExceeded)}
                  {this.getListItem(Constants.INACTIVE_PORT_ERROR_TYPE, this.state.groupedProblems.inactivePort)}
                  {this.getListItem(Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE, this.state.groupedProblems.portNotInAutonegotiation)}
                  {this.getListItem(Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE, this.state.groupedProblems.portNotInFullDuplex)}
                  {this.getListItem(Constants.INTERFACE_SPEED_ERROR_TYPE, this.state.groupedProblems.interfaceSpeedLessThan100)}
                  {this.getListItem(Constants.HARDWARE_FAULT_ERROR_TYPE, this.state.groupedProblems.portWithHardwareFault)}
                  {this.getListItem(Constants.ADDR_CONFLICT_ERROR_TYPE, this.state.groupedProblems.addressConflictDetected)}
                  {this.getListItem(Constants.MEDIA_COUNTERS_TYPE, this.state.groupedProblems.mediaCounters)}
                  {this.getListItem(Constants.INTERFACE_COUNTERS_TYPE, this.state.groupedProblems.interfaceCounters)}
                  {this.getListItem(Constants.FAULT_ERROR_TYPE, this.state.groupedProblems.faults)}
                  {this.getListItem(Constants.LOST_IP_ERROR_TYPE, this.state.groupedProblems.lostIp)}
                </List>
              </Segment>

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-problem-detected-header"
                as='h2'
                icon
                color="teal">
                <Icon name="check circle" color="teal" />
                {Strings.NO_PROBLEM_DETECTED}
                <Header.Subheader>
                  <p>{Strings.NO_EVENTS_TO_BE_ANALYZED}</p>
                </Header.Subheader>
              </Header>

            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment style={rightSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.ACTIONS}
              </Header>
              <Divider clearing />

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-task-selected-header"
                as="h2"
                icon
                color="teal">
                <Icon name='edit outline' color="teal" />
                {Strings.NO_EVENT_SELECTED}
                <Header.Subheader>
                  {Strings.CHOOSE_AN_EVENT}
                </Header.Subheader>
              </Header>

              <Segment id="task-details" style={taskSegmentStyle}>

                <Button
                  style={closeButtonStyle}
                  size="tiny"
                  circular
                  icon="times"
                  onClick={this.handleCloseButtonClick} />

                {this.getActions()}
                {this.getProblemCards()}

              </Segment>

            </Segment>

          </Grid.Column>

        </Grid>

        <Modal style={modalStyle} centered open={this.state.showModal} onClose={this.closeModal} size='small'>
          <Header icon='trash' content={Strings.PORT_IS_STILL_INACTIVE} />
          <Modal.Content>
            <p>{Strings.MARK_PROBLEM_AS_SOLVED}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.closeModal}>
              <Icon name='times' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleCheckProblemClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <div style={lastUpdateContainerStyle}>
          <div>
            <p>
              <b>{Strings.LAST_UPDATED}</b>
              {this.state.lastUpdate.toLocaleString(Strings.DATE_LOCALE)}
              {Strings.THIS_COMPUTER_TIME}
            </p>
          </div>
          <div>
            <Button
              style={{ marginLeft: "8px" }}
              circular
              color="teal"
              icon="refresh"
              onClick={this.retrieveData2} />
          </div>
        </div>

      </div >
    );
  }
}

const mapStateToProps = state => ({
  solveProblem: state.solveProblem,
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px"
};

const leftSegmentStyle = {
  height: "66vh"
};

const rightSegmentStyle = {
  height: "66vh"
};

const listSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const taskSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const noTaskHeaderSelectedStyle = {
  marginTop: "14vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};

const closeButtonStyle = {
  //zIndex: "10",
  //marginRight: "0"
};

const pdfLinkStyle = {
  marginLeft: "8px"
};

const mediaInterfaceCountersPdfLinkStyle = {
  textAlign: "center",
  marginTop: "1vh"
};

const modalStyle = {
  width: "800px",
  height: "185px",
  margin: "20vh auto"
};

const lastUpdateContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "8px"
};

const floatStyle = {
  float: "right",
  textAlign: "right"
};

const networkTagStyle = {
  color: "#576577"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(TSExpert));
